import { Injectable } from '@angular/core';
import { BehaviorSubject, from } from 'rxjs';
import { filter, tap, map, find, switchMap, distinct, toArray } from 'rxjs/operators';
import { ApplicationViewsResource, ClientApi, LedgerResource, ViewInfoResource } from 'src/app/client-api.service';
import { ViewInfo } from 'src/app/ledgers/view-info';

@Injectable({
  providedIn: 'root'
})
export class ApplicationViewsService {

  private applicationViews = new BehaviorSubject<ApplicationViewsResource[]>([]);
  readonly applicationViews$ = this.applicationViews.asObservable();

  private ledgers = new BehaviorSubject<LedgerResource[]>([]);
  readonly ledgers$ = this.ledgers.asObservable();

  private viewInfos = new BehaviorSubject<ViewInfoResource[]>([]);
  readonly viewInfos$ = this.viewInfos.asObservable();

  constructor(private apiClient: ClientApi) { }

  deleteApplicationView(id: number) {
    return this.apiClient.deleteApplicationView(id);
  }

  deleteApplicationViews(id: number[]) {
    return this.apiClient.deleteApplicationViews(id);
  }

  setApplicationViews() {
    this.getApplicationViews().subscribe(res => this.applicationViews.next(res));
  }

  getApplicationViews() {
    return this.apiClient.getApplicationViews().pipe(map(res => res));
  }

  getApplicationView(id: number) {
    return this.apiClient.getApplicationView(id);
  }

  getApplicationViewsCategories() {
    return this.apiClient.getViewInfos();
  }  

  getApplicationViewsByCategory(view: string) {
    return this.apiClient.getApplicationViewsByCategory(view);
  }

  getDisctinctAccountCodes() {
    return this.applicationViews$.pipe(
      // Convert array to individual emissions
      map(av => {
        return av.filter((obj, index, self) => {
          const key = `${obj.accountCode}-${obj.parentAccountCode}`;
          return index === self.findIndex(o => `${o.accountCode}-${o.parentAccountCode}` === key);
        });
      })
    )
  }

  putApplicationView(applicationViewResource: ApplicationViewsResource) {
    return this.apiClient.putApplicationView(applicationViewResource);
  }


  putApplicationViews(applicationViewResources: ApplicationViewsResource[]) {
    return this.apiClient.putApplicationViews(applicationViewResources);
  }



  refreshApplicationViews() {
    this.setApplicationViews();
  }

  //Ledgers
  setLedgers() {
    this.getLedgers().subscribe(res => this.ledgers.next(res));
  }

  getLedgers() {
    return this.apiClient.getLedgersForList().pipe(map(res => res));
  }

  //View Info

  setViewInfos() {
    this.getViewInfos().subscribe(res => this.viewInfos.next(res));
  }

  getViewInfos() {
    return this.apiClient.getViewInfos().pipe(map(res => res));
  }

  getViewInfo(viewId: number) {
    return this.viewInfos$.pipe(      
      map(v => {        
        return v.find(v => v.viewId === viewId);
      })
    )
  }

  putViewInfo(viewInfoResource: ViewInfoResource) {
    return this.apiClient.putViewInfo(viewInfoResource);
  }
}
